import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import Button from "../../components/button/Button";
import {illustration} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

// 直接使用 portfolio.js 的静态数据
import {
  greeting as staticGreeting,
  socialMediaLinks as staticSocial
} from "../../portfolio";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);

  // 静态数据
  const g = staticGreeting;
  const social = staticSocial;

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {g.title} <span className="wave-emoji">{emoji("👋")}</span>
              </h1>

              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {g.subTitle}
              </p>

              <div id="resume" className="empty-div"></div>

              {/* 社交链接 */}
              <div className="social-media-div" style={{marginTop: 12}}>
                {social.github && (
                  <a
                    className="icon-button github"
                    href={social.github}
                    target="_blank"
                    rel="noreferrer"
                    title="GitHub"
                  >
                    <i className="fab fa-github"></i>
                  </a>
                )}

                {social.linkedin && (
                  <a
                    className="icon-button linkedin"
                    href={social.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    title="LinkedIn"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                )}

                {social.gmail && (
                  <a
                    className="icon-button google"
                    href={`mailto:${social.gmail}`}
                    title="Email"
                  >
                    <i className="fab fa-google"></i>
                  </a>
                )}
              </div>

              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />

                {g.resumeLink ? (
                  <a
                    href={g.resumeLink}
                    target="_blank"
                    rel="noreferrer"
                    className="download-link-button"
                  ></a>
                ) : (
                  <a
                    href={require("./resume.pdf")}
                    download="Resume.pdf"
                    className="download-link-button"
                  >
                    <Button text="Download my resume" />
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              />
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
